const Spinner = () => {
  return (
    <>
      <span className="w-6 h-6 border-black rounded-full border-2 border-b-transparent animate-spin border-[inherit]" />
    </>
  );
};

export { Spinner };
